import Vue from 'vue';

import DocumentTable from './pages/DocumentTable.vue';
import UpdateDocumentTable from './pages/UpdateDocumentTable.vue';
import InvestmentProcess from './pages/InvestmentProcess.vue';
import IndividualStatusForm from './pages/IndividualStatusForm/IndividualStatusForm.vue';
import EntityStatusForm from './pages/IndividualStatusForm/EntityStatusForm.vue';
import MyOfferingsPage from './pages/MyOfferingsPage.vue'
import Tabs from './components/Tabs.vue';
import Tab from './components/Tab.vue';
import CurrencyInput from './components/CurrencyInput.vue';
import MultiPageForm from './components/MultiPageForm.vue';
import Page from './components/Page.vue';
import RevealBlock from './components/RevealBlock.vue';
import LandingPage from './pages/LandingPage.vue';
import ModalHelp from './components/ModalHelp.vue';
import SinNumber from './components/SinNumber.vue';
import PhoneNumber from './components/PhoneNumber.vue';
import ConfirmForm from './components/ConfirmForm.vue';
import ConfirmModal from './components/ConfirmModal.vue';
import InvestmentTable from './components/InvestmentTable.vue';
import CoopConsole from './components/CoopConsole.vue';
import AuditorConsole from './components/AuditorConsole.vue';
import Wysiwyg from './components/Wysiwyg.vue';
import VariableCountFormSection from './components/VariableCountFormSection.vue';
import DataRoomVideo from './components/DataRoomVideo.vue';
import DataRoomModal from './components/DataRoomModal.vue';
import ConsentModal from './components/ConsentModal.vue';
import CollapseSection from './components/CollapseSection.vue';
import IframeModal from './components/IframeModal.vue';
import OfferingCommission from "./components/OfferingCommission";
import SignFrame from "./components/SignFrame";
import SignHelp from "./components/SignHelp";
import RegistrationAccount from "./components/RegistrationAccount";
import RegistrationStatus from "./components/RegistrationStatus";
import RegistrationSign from "./components/RegistrationSign";
import CompleteClose from "./components/CompleteClose";
import OfferingMode from "./components/OfferingMode";
import DateInput from "./components/DateInput";
import FfbaOptions from "./components/ffba/FfbaOptions";
import FfbaIndividual from "./components/FfbaIndividual";
import FfbaEntity from "./components/FfbaEntity";
import OfferingAdmin from "./components/OfferingAdmin";
import OfferingView from "./components/OfferingView";
import OfferingList from "./components/OfferingList";
import ActionBtn from "./components/ActionBtn";
import EmdContactModal from "./components/EmdContactModal";
import ReportCreate from "./components/reports/ReportCreate";
import ReportDetail from "./components/reports/ReportDetail";
import ReportsIndex from "./components/reports/ReportsIndex";
import ReportTranscations from "./components/reports/ReportTranscations";
import InvestorNav from "./components/investor/InvestorNav";
import ChangePasswordBtn from "./components/auth/ChangePasswordBtn";
import CreatePassword from "./components/auth/CreatePassword";
import NonBrokeredConsole from "./components/NonBrokeredConsole";
import TaxFormInputs from "./components/flow/TaxFormInputs";
import TaxFormEntity from "./components/forms/TaxFormEntity";
import TaxFormSpouse from "./components/forms/TaxFormSpouse";
import TaxFormWrapper from "./components/forms/TaxFormWrapper";
import ConsoleChangeDRModal from "./components/ConsoleChangeDRModal";
import RevealClick from "./components/RevealClick";
import CorporateInformation from "./components/CorporateInformation";
import PaymentAtClose from "./components/PaymentAtClose";
import DistributionForm from "./components/DistributionForm";
import PhoneNumberInt from "./components/PhoneNumberInt";
import TinNumberInt from "./components/TinNumberInt";
import SsnNumber from "./components/SsnNumber";
import UserProfile from "./components/user/UserProfile";
import UserRegisterProfile from "./components/user/UserRegisterProfile";
import ReportsNav from "./components/reports/ReportsNav";
import OfferingCreateForm from "./components/forms/OfferingCreateForm";
import CounterSignFrame from "./components/CounterSignFrame"
import CounterSignerEdit from './components/CounterSignerEdit';
import Store from './store.js';
import $ from 'jquery';
import {wait} from "./util";
import _ from 'underscore';
import InviteDealingRepTeam from "./components/investor/InviteDealingRepTeam";
import InviteCcoTeam from "./components/investor/InviteCcoTeam";
import InviteEmdAdminTeam from "./components/investor/InviteEmdAdminTeam";
import InviteAuditorTeam from "./components/investor/InviteAuditorTeam";
import InviteCounterSignerTeam from "./components/investor/InviteCounterSignerTeam";
import InviteTeamModal from "./components/investor/InviteTeamModal";
import ClosingInvestmentsTable from "./components/admin/ClosingInvestmentsTable";
import TrusteeSelector from "./components/admin/TrusteeSelector.vue";

window._ = _;
window.store = Store;
window.$ = window.jQuery = $;

require('bootstrap-sass');

if(!window.Promise) {
    window.Promise = require('es6-promise').Promise;
}

const vm = new Vue({
    'el': 'main',
    components: {
        DocumentTable,
        InvestmentProcess,
        RevealBlock,
        Tabs,
        Tab,
        CurrencyInput,
        MultiPageForm,
        Page,
        EntityStatusForm,
        IndividualStatusForm,
        VariableCountFormSection,
        ModalHelp,
        SinNumber,
        PhoneNumber,
        DataRoomVideo,
        InvestmentTable,
        CoopConsole,
        AuditorConsole,
        Wysiwyg,
        ConfirmForm,
        ConfirmModal,
        DataRoomModal,
        ConsentModal,
        CollapseSection,
        IframeModal,
        OfferingCommission,
        SignFrame,
        SignHelp,
        RegistrationAccount,
        RegistrationStatus,
        CompleteClose,
        OfferingMode,
        DateInput,
        FfbaOptions,
        FfbaIndividual,
        FfbaEntity,
        OfferingAdmin,
        OfferingView,
        OfferingList,
        ActionBtn,
        EmdContactModal,
        ReportCreate,
        ReportDetail,
        ReportsIndex,
        InvestorNav,
        ChangePasswordBtn,
        CreatePassword,
        NonBrokeredConsole,
        TaxFormInputs,
        TaxFormEntity,
        TaxFormSpouse,
        TaxFormWrapper,
        ConsoleChangeDRModal,
        RevealClick,
        CorporateInformation,
        PaymentAtClose,
        DistributionForm,
        PhoneNumberInt,
        TinNumberInt,
        SsnNumber,
        UserProfile,
        UserRegisterProfile,
        UpdateDocumentTable,
        RegistrationSign,
        LandingPage,
        MyOfferingsPage,
        ReportsNav,
        ReportTranscations,
        OfferingCreateForm,
        CounterSignFrame,
        CounterSignerEdit,
        InviteDealingRepTeam,
        InviteCcoTeam,
        InviteEmdAdminTeam,
        InviteAuditorTeam,
        InviteCounterSignerTeam,
        InviteTeamModal,
        ClosingInvestmentsTable,
        TrusteeSelector
    },
    events: {
        videoOpen() {
            console.log('root open')
        }
    },
    mounted() {
        $('body').click(() => this.$emit('unhandledClick'));
        wait(1).then(() => {
            $('body').addClass('js');
        });
    },
});
